<template>
  <div class="navbar yld-framework-navbar">
    <div class="left-menu" />
    <div class="right-menu">

      <!--  <span class="right-menu-record" @click="handleUpload">上传记录</span>  -->
      <!-- 用户信息 -->
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper">
          <el-avatar class="user-avatar" shape="circle" :size="30" fit="fill" :src="user.thumbAvatar || pailogo" alt="用户头像" />
          <span>{{ user.realName }}</span>
        </div>
        <el-dropdown-menu slot="dropdown" class="yld-dropdown-menu">
          <div>
            <el-dropdown-item v-if="checkFunction.includes('prime_setting')" @click.native="personal">
              <yun-icon name="icon-renwu" />
              <span>Setting</span>
            </el-dropdown-item>
            <el-dropdown-item v-if="checkFunction.includes('prime_staff')" divided @click.native="handleSettingStaff">
              <yun-icon name="icon-CarrierAccount" />
              <span>Staff Management</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <yun-icon name="icon-dengchu" />
              <span>Exit</span>
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Storage, Cookie } from '@yld/yun-utils-common'
import { BASE_URL } from '@/utils/host'
import * as Util from '../../../lang/util'
import pailogo from '@/assets/pailogo.png'

export default {
  data() {
    return {
      pailogo
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    user() {
      return this.userInfo
    },
    checkFunction() {
      return this.$store.getters.functionKey
    }
    // // 默认头像
    // defaultHeadUrl() {
    //   return require(`@/assets/defaultAvatar.png`)
    // }
  },
  mounted() {
    this.languageCode = Cookie.getCookie('_xLang_code', null, false)
    Util.toggleLanguage('en', this)
  },
  methods: {
    async logout() {
      Storage.clearStorage()
      await this.$store.dispatch('user/logout')
      window.location.replace(BASE_URL.GY_PASSPORT + '?redirect=' + encodeURIComponent(window.location.href))
    },
    personal() {
      this.$router.push('/personal')
    },
    handleSettingStaff() {
      window.open(`${BASE_URL.HOME_WORK}/90006/staffindex`, '_blank')
    },
    handleUpload() {
      this.$router.push({ name: 'uploadList' })
    }
  }
}
</script>

<style lang="scss" scoped>
.yld-framework-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-menu {
    margin-left: 12px;
  }
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    .right-menu-record{
      cursor:pointer
    }

    .navbar-download-log {
      margin-left: 16px;
      cursor: pointer;
      color: #333333;
      font-size: 14px;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 16px;
      margin-left: 16px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 100%;
          margin-right: 8px;
        }
        ::v-deep .el-avatar {
          img {
            width: 100% !important;
          }
        }
        span {
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }
}
.yujing-drawer-form {
  .warning-message {
    background: var(--geek-color-primary);
  }
  .yujing-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    line-height:22px;
    color: #E59840;
    background-color: #fdf6ec;
    border-radius: 5px;
    svg {
      margin-left:10px;
      margin-right: 5px;
    }
  }
  .yujingt-title {
    margin: 6px 0;
    padding-left: 5px;
    border-left: 3px solid var(--geek-color-primary);
    font-size: 14px;
    font-weight: 600;
    line-height:14px;
  }
}
</style>
<style lang="scss">
  .yld-dropdown-menu {
    margin: 0 !important;
    padding: 0 !important;
    .el-dropdown-menu__item {
      //padding: 12px 24px !important;
      line-height: 35px;
      margin: 0;
      svg {
        margin-right: 8px;
      }
    }
    .user-company {
        padding: 6px 0;
        display:flex;
        justify-content: space-between;
        .avatat-container {
          display: flex;
          align-items: center;
          padding-right: 15px;
        }
        .company-info {
          .company-name {
            font-size: 16px;
            line-height: 23px;
          }
          .validity {
            color: var(--geek-color-primary);
            font-size: 13px;
            line-height: 26px;
          }
          .company-status {
            span {
              display: inline-block;
              background-color: var(--geek-color-primary);
              margin-right: 10px;
              font-weight: 400;
              font-size: 12px;
              color: #fff;
              line-height:24px;
              border-radius: 2px;
              padding: 0 6px;
            }
          }
        }
        .xiangyou-icon {
          display: flex;
          align-items: center;
          padding-left: 5px;
        }
      }
    .el-dropdown-menu__item--divided:before {
      content: none
    }
    .el-dropdown-menu__item.el-dropdown-menu__item--divided {
      margin: 0 !important;
    }
  }
  .yujing-drawer-form{
    .el-drawer__body .yun-drawer-form-scroll {
      padding-top: 3px !important
    }
  }

</style>
